module.exports = __webpack_public_path__ + "static/img/jigou-gansu-top.4c14d79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-gansu-top.png
// module id = SOCM
// module chunks = 2